const globalTrackingRx = require('./globalTrackingRx');
import { RX } from './constants';

const ACTION_NAMES = {
    LOGIN: 'Login',
    TIMING: 'Timing'
};

module.exports = (flex = window.flex) => {

    globalTrackingRx(flex);

    function initialize(TrackingEvent) {
        rx(TrackingEvent);

        return ACTION_NAMES;
    }

    function rx(TrackingEvent) {
        let { onTrigger } = flex;

        onTrigger(RX.TRACK.SESSION_LOGGED_IN, ({ session = {} }) => {
            const { user = {} } = session;

            let event = new TrackingEvent(ACTION_NAMES.LOGIN),
                valuesCollection = [
                    {
                        prefix: 'Login',
                        values: {
                            sessionId: session.sessionId,
                            userPersonId: user.personId,
                            userSummary: user.summary
                        }
                    }
                ];
            event.track(valuesCollection);
        });

        onTrigger(RX.TRACK.TIMING, ({ timers = [], metadataCollection = [] }) => {
            let timerValues = timers.reduce((output, timer) => {
                output[timer.key] = timer.executionTime();
                return output;
            }, {});

            let metadataValues = metadataCollection.reduce((output, metadata) => {
                if (!metadata.prefix && !metadata.values) {
                    console.warn('Metadata provided to timing tracking must have prefix[string] and values[object] properties');
                }
                else {
                    output.push(metadata);
                }
                return output;
            }, []);

            let event = new TrackingEvent(ACTION_NAMES.TIMING),
                valuesCollection = [
                    {
                        prefix: 'Timing',
                        values: timerValues
                    }
                ];

            event.track(valuesCollection.concat(metadataValues));
        });
    }

    return initialize;
};